import { unauthenticatedApiRequest } from '@/api/helpers/unauthenticatedApiRequest';
import { type AddToWaitlistRequest } from 'schemas';

export const addToWaitlist = async (
  waitlistData: AddToWaitlistRequest
): Promise<void> => {
  // Success returns 204 No Content response - no response body to validate
  await unauthenticatedApiRequest<void, never>(
    'POST',
    '/api/waitlist',
    waitlistData
  );
};
